import { AuthenticationService } from './services/authentication.service';
import { RootComponent } from './root/root.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';


// Define the routing paths
const routes: Routes = [
  { path: '', component: RootComponent}
  //{ path: '', component: RootComponent, canActivate: [AuthenticationService]}
  //{path:'',redirectTo:'/',pathMatch: 'full',canActivate:[AuthenticationService]}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
